import React from 'react';
import { Skeleton } from 'antd';

const LocationsSkeleton: React.FC = () => {
    return (
        <div className="space-y-2">
            {[1, 2, 3, 4].map((item) => (
                <div key={item} className="space-y-2">
                    <Skeleton.Input style={{ width: 200 }} active />
                    <div className="ml-4 space-y-2">
                        {[1, 2, 3].map((subItem) => (
                            <Skeleton.Input key={subItem} style={{ width: 150 }} active />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LocationsSkeleton;